var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlogBgBlobRight = function SvgBlogBgBlobRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 236,
    height: 746,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDF0FC",
    d: "M89.743 569.894C214.72 369.177-66.458 85.376 15.657 20.489 97.773-44.398 285.921 56.86 435.898 246.658s204.989 396.259 122.874 461.146c-82.115 64.888-594.004 62.808-469.029-137.91"
  })));
};
export { SvgBlogBgBlobRight as ReactComponent };
export default "/_next/static/media/src/components/Blog/assets/blogBgBlobRight.81dea16104d05162f6ec1b6d7b4b8ad4.svg";